module.exports = __webpack_public_path__ + "img/contact-logo.1912c0ea.png";